import { render, staticRenderFns } from "./ecntype.vue?vue&type=template&id=496c3810&scoped=true&"
import script from "./ecntype.vue?vue&type=script&lang=js&"
export * from "./ecntype.vue?vue&type=script&lang=js&"
import style0 from "./ecntype.vue?vue&type=style&index=0&id=496c3810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c3810",
  null
  
)

export default component.exports